/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LineItemType {
	Subscription = 'Subscription',
	Users = 'Users',
	Merges = 'Merges',
	Templates = 'Templates',
	Prepaid = 'Prepaid',
	SignupCredit = 'SignupCredit',
	TrialCredit = 'TrialCredit',
	ManualCredit = 'ManualCredit',
	ReferralCredit = 'ReferralCredit',
	DiscountCredit = 'DiscountCredit',
	PrepaidDiscount = 'PrepaidDiscount',
	Charge = 'Charge',
	ManualDebit = 'ManualDebit',
	Refund = 'Refund',
	CheckPayment = 'CheckPayment',
	OutstandingBalance = 'OutstandingBalance',
	DocumentTemplates = 'DocumentTemplates',
	Storage = 'Storage',
	ApiUsage = 'ApiUsage',
	Guests = 'Guests',
    /**
     * Monthly base plan charge.
     */
	PlanCharge = 'PlanCharge',
    /**
     * Monthly additional users above included.
     */
	AdditionalUsersCharge = 'AdditionalUsersCharge',
    /**
     * Monthly documents above included.
     */
	AdditionalDocumentsCharge = 'AdditionalDocumentsCharge',
    /**
     * Monthly API overage buckets.
     */
	AdditionalApiRequestsCharge = 'AdditionalApiRequestsCharge',
    /**
     * Monthly guest tier charge.
     */
	AdditionalGuestsCharge = 'AdditionalGuestsCharge',
    /**
     * Monthly storage overage.
     */
	AdditionalStorageCharge = 'AdditionalStorageCharge',
    /**
     * Prorated new plan remainder-of-month.
     */
	PlanProrationCharge = 'PlanProrationCharge',
    /**
     * Negative credit for old plan remainder-of-month.
     */
	PriorPlanProrationCredit = 'PriorPlanProrationCredit',
    /**
     * Annual plan funding through renewal.
     */
	AnnualPlanCommitFunding = 'AnnualPlanCommitFunding',
    /**
     * Annual committed users funding.
     */
	AnnualUserCommitFunding = 'AnnualUserCommitFunding',
    /**
     * Wallet funding (manual or automatic).
     */
	UsageWalletFunding = 'UsageWalletFunding',
    /**
     * Credit for leftover usage wallet balance applied to renewal or converted on frequency change.
     */
	UsageWalletCredit = 'UsageWalletCredit',
    /**
     * Credit applied to reduce invoice due.
     */
	CreditApplied = 'CreditApplied',
    /**
     * Credit issued to increase balance.
     */
	CreditIssued = 'CreditIssued',
    /**
     * Documents forced downgrade.
     */
	ForcedDowngradeNotice = 'ForcedDowngradeNotice',
    /**
     * Revenue reduction for prior-month uncollectable revenue.
     */
	RevenueReversalAdjustment = 'RevenueReversalAdjustment',
    /**
     * Direct cash-balance adjustment recorded on an internal CashAdjustment invoice.
     */
	CashAdjustment = 'CashAdjustment',
}
